import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function CountdownTimer() {
  return <div className="bg-gradient-to-r from-emerald-600 to-cyan-600 text-white py-4 px-4" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <div className="flex items-center justify-center gap-3" data-id="element-81">
          <SparklesIcon className="w-6 h-6 text-yellow-300" data-id="element-82" />
          <p className="text-lg font-semibold" data-id="element-83">
            Precio especial disponible hoy
          </p>
          <SparklesIcon className="w-6 h-6 text-yellow-300" data-id="element-84" />
        </div>
      </div>
    </div>;
}